module.exports = __webpack_public_path__ + "static/img/2_1_2.8813b9f8.jpg";